import { ColumnDef } from '@tanstack/react-table';
import i18n from 'i18next';

import { TableData } from '@/types';

export const getVideoThemeClipColumns: () => ColumnDef<TableData>[] = () => {
  const defaultVideoThemeColumns: ColumnDef<TableData>[] = [
    {
      id: 'type',
      accessorKey: 'type',
      header: i18n.t('type', { ns: 'common' })
    },
    {
      id: 'order',
      accessorKey: 'order',
      header: i18n.t('order', { ns: 'common' })
    },
    {
      id: 'assetName',
      accessorKey: 'assetName',
      header: i18n.t('assetName', { ns: 'common' })
    }
  ];

  return defaultVideoThemeColumns;
};
